module.exports = __webpack_public_path__ + "img/logo2.38429eb8.png";